module.exports = __webpack_public_path__ + "2acfc264.png";